module.exports = __webpack_public_path__ + "static/media/pays.4eb9446a.png";